export default "__VITE_ASSET__DgbHh0r6__"